export const environment = {
  production: false,
  releaseOnboarding: {
    deploymentDate: '2026-10-26',
    releaseId: '2026-10-26',
  },
  apiUrl: 'https://apim-np-t-idb-integration.iadb.org/ext/api/knp/v1/',
  msalConfig: {
    // clientId: '4d8b75b4-90d3-4922-8b9e-edb23eafcf72',//dev
    clientId: '4d46266a-863a-44f7-b97d-c3b23512cf49', //test
    authority: 'https://login.microsoftonline.com/9dfb1a05-5f1d-449a-8960-62abcb479e7d',
    redirectUri: 'https://knowledgeplatform-np-t.iadb.org',
    postLogoutRedirectUri: 'https://knowledgeplatform-np-t.iadb.org',
    subscription_key: 'a312cca5597043d5ab7b64cb326c5bad',
    // scopes: ['api://8401c8a9-7aca-4ee7-aee4-683f054682b8/access_as_user'], // dev
    scopes: ['api://95fcec48-c048-4d74-bd09-5c4398e7919d/access_as_user'], //test
    protectedResourceMap: [
      {
        url: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['access_as_user'],
      },
    ],
  },
};
